<!-- Copyright (C) 2023-2025 Skylark Drones -->
<template>
  <v-card class="rounded-lg overflow-hidden" height="50vh" max-height="60vh">
    <v-img
      position="center top"
      :src="background"
      :height="homeCardImageHeight"
      style="position: absolute; bottom: 0; left: 0; width: 100%"
    />
    <v-row
      no-gutters
      class="px-4 px-md-15 pt-4 pt-md-6 text-center text-md-left"
      style="position: relative"
    >
      <v-col cols="12" md="">
        <div class="text-h4 text-md-h2 font-weight-bold">
          {{ appName }}
        </div>
        <div class="text--secondary mt-2 mt-md-4">
          {{ subtitleOfTheDay }}
        </div>
        <v-row no-gutters class="mt-8 d-inline-flex">
          <v-col cols="auto">
            <v-btn
              color="primary"
              rounded
              depressed
              @click="openRegisterDialog"
            >
              Get Started
            </v-btn>
            <register-card
              v-if="showRegisterDialog"
              @close="showRegisterDialog = false"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'

import background from '@/assets/images/homepage-hero-bg.png'
import { randomNumberInRange } from '@/utils/common'
import { page } from '@/utils/analytics/abstraction/eventEnums'
const RegisterCard = () => import('@/components/homepage/RegisterCard')

export default {
  name: 'HomePageHeroCard',

  components: {
    RegisterCard
  },

  data() {
    return {
      background,
      showRegisterDialog: false
    }
  },

  computed: {
    ...mapGetters('brand', ['appNameAbbr', 'appName']),
    subtitleOfTheDay() {
      const homeCardSubtitle = [
        'The future of drone operations, Today',
        `Dream it, Drone it, ${this.appNameAbbr} it`,
        'Capturing reality in a snap',
        'Improving your map, 1 cm/px at a time',
        `Plan the unplanned with ${this.appNameAbbr}, Go Live`,
        'Your on-site wingman',
        'Your co-pilot on the ground'
      ]
      const num = randomNumberInRange(0, homeCardSubtitle.length - 1)
      return homeCardSubtitle[num]
    },
    homeCardImageHeight() {
      let height = 60

      if (this.$vuetify.breakpoint.lgAndUp) {
        height = 90
      }

      if (this.$vuetify.breakpoint.md) {
        height = 55
      }

      if (this.$vuetify.breakpoint.smAndDown) {
        height = 50
      }

      return `${height}%`
    }
  },

  methods: {
    openRegisterDialog() {
      this.$analytics.trackSignupView(page.HomePage)
      this.showRegisterDialog = true
    }
  }
}
</script>
